module.exports = __webpack_public_path__ + "img/c00_buildingtechpullsaw_Normal_ua.d87fc2bc.webp";